/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArtistAliasCreateSourceIds } from './ArtistAliasCreateSourceIds';
import {
    ArtistAliasCreateSourceIdsFromJSON,
    ArtistAliasCreateSourceIdsFromJSONTyped,
    ArtistAliasCreateSourceIdsToJSON,
} from './ArtistAliasCreateSourceIds';

/**
 * 
 * @export
 * @interface ArtistBandCreate
 */
export interface ArtistBandCreate {
    /**
     * 
     * @type {string}
     * @memberof ArtistBandCreate
     */
    stageName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistBandCreate
     */
    manualStageName?: boolean;
    /**
     * 
     * @type {ArtistAliasCreateSourceIds}
     * @memberof ArtistBandCreate
     */
    sourceIds: ArtistAliasCreateSourceIds;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistBandCreate
     */
    isPermanentMember?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistBandCreate
     */
    isMainPerformer?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArtistBandCreate
     */
    linkedAliasId?: string | null;
}

/**
 * Check if a given object implements the ArtistBandCreate interface.
 */
export function instanceOfArtistBandCreate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "sourceIds" in value;

    return isInstance;
}

export function ArtistBandCreateFromJSON(json: any): ArtistBandCreate {
    return ArtistBandCreateFromJSONTyped(json, false);
}

export function ArtistBandCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistBandCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stageName': json['stageName'],
        'manualStageName': !exists(json, 'manualStageName') ? undefined : json['manualStageName'],
        'sourceIds': ArtistAliasCreateSourceIdsFromJSON(json['source_ids']),
        'isPermanentMember': !exists(json, 'is_permanent_member') ? undefined : json['is_permanent_member'],
        'isMainPerformer': !exists(json, 'is_main_performer') ? undefined : json['is_main_performer'],
        'linkedAliasId': !exists(json, 'linked_alias_id') ? undefined : json['linked_alias_id'],
    };
}

export function ArtistBandCreateToJSON(value?: ArtistBandCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stageName': value.stageName,
        'manualStageName': value.manualStageName,
        'source_ids': ArtistAliasCreateSourceIdsToJSON(value.sourceIds),
        'is_permanent_member': value.isPermanentMember,
        'is_main_performer': value.isMainPerformer,
        'linked_alias_id': value.linkedAliasId,
    };
}

